import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'app/app.component';
import { ConfigService } from 'app/services';
import { AppConfig } from 'app/models';
import { Subscription } from 'rxjs';

@Component({
    selector: 'config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {
    themes: any[] = [];

    theme = 'purple';

    config: AppConfig = {};

    subscription: Subscription | undefined = undefined;

    constructor(public app: AppComponent, public configService: ConfigService) {
        // Copy some AppComponent properties to ConfigService
        this.configService.config.menuMode = this.app.menuMode;
        this.configService.config.sidebarStatic = this.app.sidebarStatic;
    }

    ngOnInit() {
        this.changeTheme(this.theme);
        this.config = this.configService.config;
        this.subscription = this.configService.configUpdate$.subscribe(config => {
            this.config = config;
        });

        this.themes = [
            { name: 'avocado', color: '#AEC523' },
            { name: 'blue', color: '#5297FF' },
            { name: 'purple', color: '#464DF2' },
            { name: 'teal', color: '#14B8A6' },
            { name: 'green', color: '#34B56F' },
            { name: 'indigo', color: '#6366F1' },
            { name: 'orange', color: '#FF810E' },
            { name: 'red', color: '#FF9B7B' },
            { name: 'turquoise', color: '#58AED3' },
            { name: 'yellow', color: '#FFB340' },
        ];
    }

    onChangeTopbar(mode: string) {
        this.app.menuTheme = mode;
    }

    changeColorScheme(scheme: string) {
        this.changeStyleSheetsColor('layout-css', 'layout-' + scheme + '.css', 1);
        this.changeStyleSheetsColor('theme-css', 'theme-' + scheme + '.css', 1);

        this.app.darkMode = scheme;
        this.app.topbarTheme = scheme;
        this.app.menuTheme = scheme;

        this.configService.updateConfig({ ...this.config, ...{ dark: scheme === 'dark' } });
    }

    changeTheme(theme: string) {
        this.theme = theme;
        this.changeStyleSheetsColor('theme-css', theme, 2);
    }

    changeStyleSheetsColor(id: any, value: any, from: any) {
        const element = document.getElementById(id);

        if (!element) {
            return;
        }

        const urlTokens = element.getAttribute('href')?.split('/') || [];

        if (from === 1) {           // which function invoked this function - change scheme
            urlTokens[urlTokens.length - 1] = value;
        } else if (from === 2) {       // which function invoked this function - change color
            urlTokens[urlTokens.length - 2] = value;
        }

        const newURL = urlTokens.join('/');

        this.replaceLink(element, newURL);
    }

    replaceLink(linkElement: HTMLElement, href: string) {
        if (this.isIE()) {
            linkElement.setAttribute('href', href);
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true) as HTMLElement;

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            if (linkElement.parentNode) {
                linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
            }

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id || '');
            });
        }
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    onConfigButtonClick(event: Event) {
        this.app.configActive = !this.app.configActive;
        this.app.configClick = true;
        event.preventDefault();
    }

    public onHorizontalMenuClick(): void {
        this.app.menuTheme = this.app.topbarTheme;
        this.app.sidebarStatic = false;
        this.app.sidebarActive = false;

        // Copy some AppComponent properties to ConfigService
        this.configService.config.menuMode = this.app.menuMode;
        this.configService.config.sidebarStatic = this.app.sidebarStatic;
    }

    public onSidebarMenuClick(): void {
        // Copy some AppComponent properties to ConfigService
        this.configService.config.menuMode = this.app.menuMode;
        this.configService.config.sidebarStatic = this.app.sidebarStatic;
    }

    public onSlimMenuClick(): void {
        this.app.sidebarStatic = false;
        this.app.sidebarActive = false;

        // Copy some AppComponent properties to ConfigService
        this.configService.config.menuMode = this.app.menuMode;
        this.configService.config.sidebarStatic = this.app.sidebarStatic;
    }
}
